import { toast } from 'react-toastify';

export const BAD_REQUEST_ERROR_CODE = 400;
export const VALIDATION_ERROR_CODE = 422;
export const UNAUTHORIZED_ERROR_CODE = 401;
export const NOT_FOUND_ERROR_CODE = 404;
export const ERROR_MESSAGE = 'Sorry, we are having difficulties';

export function handleValidationError(error: any) {
  // Some validation errors will be handled at the top. For those which don't need we will use this flag to show a toast
  // error message
  let showToast = true;

  let message = '';
  const responseURL = error?.request ? error.request.responseURL : '';
  const errors = error.response?.data.errors;
  if (!(errors instanceof Object)) return;

  Object.keys(errors).forEach((field) => {
    errors[field].forEach((validationError: any) => {
      const validation = validationError.split('.');
      if (validation.length !== 2 || validation[0] !== 'validation') {
        message = validationError;
        return;
      }

      if (validation[1].indexOf('required') === 0) {
        message = `The ${field} must be filled`;
      }

      if (validation[1].indexOf('unique') === 0) {
        message = `The ${field} is already registered`;
        if (responseURL.includes('/api/register')) {
          showToast = false;
        }
      }
    });
  });

  if (showToast) {
    toast.warning(message || error.response.data.message);
  }

  throw error;
}

/**
 * If an error object is passed capture the exception and throw a generic error.
 *
 * @param error
 * @param shouldShowToast default value is true
 */
export function handleGenericError(error: any, shouldShowToast = true) {
  if (shouldShowToast) {
    toast.warning(ERROR_MESSAGE);
  }
  throw new Error(ERROR_MESSAGE);
}

/**
 * Handle generic request error
 *
 * @param error
 * @param shouldShowToast
 */
export function handleRequestError(error: any, shouldShowToast = true) {
  // Authorization error will be handled by apiClient
  if (error.response?.status === UNAUTHORIZED_ERROR_CODE) {
    const originalRequest = error.config;
    const response = error.response.data;

    if (
      originalRequest?.url === process.env.NEXT_PUBLIC_APP_API_LOGIN_URL &&
      response.message
    ) {
      toast.warning(response.message);
    }

    return;
  }
  if (error.response?.status === VALIDATION_ERROR_CODE) {
    handleValidationError(error);
  }

  if (error.response?.status === BAD_REQUEST_ERROR_CODE) {
    if (shouldShowToast) {
      const response = error.response?.data;
      if (response.message) {
        toast.warning(response.message);
      } else if (
        response.errors &&
        Array.isArray(response.errors) &&
        response.errors[0] &&
        response.errors[0].title
      ) {
        toast.warning(response.errors[0].title);
      }
    }
    throw error;
  }

  if ([NOT_FOUND_ERROR_CODE].indexOf(error.response?.status)) {
    throw error;
  }

  handleGenericError(error, shouldShowToast);
}
